import React, { useState, useEffect } from "react";
import TopHeader from "./nav_top.js";

import UserReport from "./_200_user_report.js";
import "./styles.css";
import TradeTagTable from "./_47_trade_tag_table.js";

const MODULE_NAME = "pg_tags";

const activeDate = new Date().toLocaleDateString("en-US"); // MM/DD/YY
const screen = "pg_tags";

/**
 * pg_tags Component
 * This component displays the tagging center with trade tag management.
 */
const pg_tags = ({ onNavigate, setScreen: setAppScreen }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const triggerRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const handleNavigateToMonitor = (destination) => {
    // Use parent setAppScreen if available, otherwise use onNavigate callback
    if (setAppScreen) {
      setAppScreen(destination);
    } else if (onNavigate) {
      onNavigate(destination);
    }
  };

  // Clean up query string once component mounts
  useEffect(() => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // Remove query parameters that shouldn't persist on tags page
    params.delete("date");
    params.delete("symbol");

    // Update browser history without reloading
    const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.replaceState({}, "", newUrl);
  }, []);

  return (
    <div style={{ width: "100%" }} data-analytics={MODULE_NAME}>
      <TopHeader
        screen={screen}
        refreshKey={refreshKey}
        onNavigate={handleNavigateToMonitor}
      />
      <TradeTagTable
        onNavigate={handleNavigateToMonitor}
        screen={screen}
        activeDate={activeDate}
        refreshKey={refreshKey}
      />
    </div>
  );
};

export default pg_tags;